import StarHalfSVG from "@design-system/ui-icons/vanilla/StarHalf"
import { createIcon } from "../createIcon"

export const StarHalfIcon = createIcon(StarHalfSVG)
